import { render, staticRenderFns } from "./ReceiveModal.vue?vue&type=template&id=0b19996e&"
import script from "./ReceiveModal.vue?vue&type=script&lang=js&"
export * from "./ReceiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports